import React from 'react';
import { APPRAISER_EVENT_STAGE } from '../../../../../constants/AppraiserEventStage';
import { showWarningToast } from '@shared/services/toastService';
import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import EventReturnInputValidator from '../validator/EventReturnInputValidator';
import EventReturnDialogContent from './EventReturnDialogContent';
import ConfirmDialogWithButton from '@shared/components/confirmDialog/ConfirmDialogWithButton';
import FormProviderWrapper from '@shared/components/confirmDialog/dialogWrappers/FormProviderWrapper';
import { DIALOG_MODES } from '@shared/components/confirmDialog/dialogWrappers/constants/DialogModes';

const REVIEW_EVENT_RETURNED_MESSAGE = 'Describe requested changes for the appraisal details.';
const REVIEW_EVENT_RETURNED_TEXT = 'returned';
const RETURN_BUTTON_TEXT = 'Return';
const CANCEL_BUTTON_TEXT = 'Cancel';

/**
 * @typedef {object} EventReturnActionButtonProps
 * @property {(stage: number, reviewActionText: string, notes: string) => void | Promise<void>} handleConfirm
 * @property {() => boolean | Promise<boolean>} openModalPreCondition
 */

/**
 * @param {EventReturnActionButtonProps} props
 */
const EventReturnActionButton = props => {
  const { handleConfirm, openModalPreCondition } = props;

  const form = useForm({
    resolver: joiResolver(EventReturnInputValidator.schema),
    defaultValues: { returnNotes: '' }
  });

  const { reset } = form;

  const handleClose = () => {
    reset();
  };

  const onSubmit = async data => {
    await handleConfirm(
      APPRAISER_EVENT_STAGE.ATL_ASSIGNED_RETURNED,
      REVIEW_EVENT_RETURNED_TEXT,
      data.returnNotes
    );
    handleClose();
  };

  const onError = errors => {
    const errorMessage = errors?.returnNotes?.message;
    if (errorMessage) {
      showWarningToast(errorMessage);
    }
  };

  return (
    <FormProviderWrapper form={form} onError={onError}>
      <ConfirmDialogWithButton
        message={REVIEW_EVENT_RETURNED_MESSAGE}
        openModalBtnText={RETURN_BUTTON_TEXT}
        confirmBtnText={RETURN_BUTTON_TEXT}
        cancelBtnText={CANCEL_BUTTON_TEXT}
        openModalBtnType='secondary-button'
        openModalBtnClassName='delete-button-secondary'
        dialogClassName='event-return-dialog'
        handleOnClose={reset}
        openModalPreCondition={openModalPreCondition}
        handleOnConfirm={onSubmit}
        dialogContent={<EventReturnDialogContent />}
        dialogMode={DIALOG_MODES.INTERNAL_FORM}
      />
    </FormProviderWrapper>
  );
};

export default EventReturnActionButton;
